"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfessionForm = exports.DEFAULT_FORM = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const profession_types_1 = require("@front/types/profession.types");
const backendImport_1 = require("@front/backendImport");
const component_3 = require("@front/layouts/default-layout/component");
exports.DEFAULT_FORM = {
    name: '',
    description: '',
    branch_id: '',
    image: null,
    knowledgeIds: [],
    stepIds: [],
    common: false,
    active: true
};
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="container-fluid">
    <div class="profession-form-page">
      <div class="row">
        <div class="col-lg-8 col-12 pb-lg-5">
          <div class="mb-2">
            <h1>${x => x.professionId ? 'profession.edit.title'.t() : 'profession.create.title'.t()}</h1>
            <div class="text-zero top-right-button-container">
              <button @click="${(x, c) => x.back()}" type="button"
                class="top-right-button mr-1 btn btn-primary btn-lg">${'profession.form.back'.t()}</button>
            </div>
          </div>
          <div class="card card-body mb-5">
            <the-form :onSubmit="${(x, c) => x.handleSubmit.bind(x)}">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <part-input 
                    required="true" 
                    class="form-part" 
                    label="${'profession.form.name.label'.t()}" 
                    :value="${x => x.form.name}"
                    name="name" 
                    placeholder="${'profession.form.name.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-6">
                  <part-select 
                    class="form-part" 
                    label="${'profession.form.branch.label'.t()}" 
                    :value="${x => x.form.branch_id}"
                    name="branch_id" 
                    placeholder="${'profession.form.branch.placeholder'.t()}" 
                    :options="${x => x.branchOptions}"
                  ></part-select>
                </div>
              </div>
                <div class="form-group">                
                <part-checkbox 
                  class="form-part"
                  label="${'profession.form.steps.label'.t()}"
                  horizontal="true"
                  name="stepIds"
                  multiple="true"
                  :value="${x => x.form.stepIds}"
                  :options="${x => x.stepOptions}"
                  @change="${(x, c) => x.onStepSelectionChanged.bind(x)(c.event)}"
                ></part-checkbox>
              </div>            
              <div class="form-group">
                <part-textarea 
                  class="form-part" 
                  label="${'profession.form.description.label'.t()}" 
                  :value="${x => x.form.description}"
                  name="description" 
                  placeholder="${'profession.form.description.placeholder'.t()}"
                ></part-textarea>
              </div>
              
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label>${'profession.form.image.label'.t()}</label>
                    <part-file-upload 
                      class="form-part"
                      :value="${x => x.form.image}"
                      name="image" 
                      accept="image/*"
                      @fileUploaded="${(x, c) => x.onImageUpload.bind(x)}"
                      ></part-file-upload>
                  </div>
                  <div class="col-6">
                    ${(0, fast_element_1.when)(x => x.isUserSuperAdmin, (0, fast_element_1.html) `
                    <part-switch class="form-part" label="${'profession.form.common.label'.t()}" :value="${x => x.form.common}"
                    name="common"
                    ></part-switch>
                    `)}
                    ${(0, fast_element_1.when)(x => x.isUserParentOrAdmin, (0, fast_element_1.html) `
                    <part-switch class="form-part" label="${'profession.form.active.label'.t()}" :value="${x => x.form.active}"
                    name="active"
                    ></part-switch>
                    `)}
                  </div>
                </div>                
              </div>
              <div class="form-group">                             
                <knowledge-picker 
                  class="form-part"
                  forcedShow="true"
                  :selectedIds="${x => x.form.knowledgeIds ? x.form.knowledgeIds.join(',') : ''}"
                  :initial-show="${x => x.form.knowledgeIds && x.form.knowledgeIds.length > 0}"
                  placeholder="${'profession.form.knowledge.placeholder'.t()}"
                  @selectionChanged="${(x, c) => x.onKnowledgeSelectionChanged.bind(x)(c.event)}"
                ></knowledge-picker>
              </div>
                        
              <div class="form-group mt-4">
                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                  ?disabled="${x => x.loading}">
                  ${x => x.professionId ? 'profession.edit.title'.t() : 'profession.create.title'.t()}
                </button>
              </div>
            </the-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.profession-form-page .branch-select {
  width: 100%;
}

knowledge-picker {
  z-index: 5;
  position: relative;
}`;
const shadowOptions = { "mode": "open" };
let ProfessionForm = class ProfessionForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.professionId = null;
        this.form = exports.DEFAULT_FORM;
        this.branchOptions = [];
        this.stepOptions = [];
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_3.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_3.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.professionId = this.routeParams.id;
        // Initialize form first
        this.form = {
            name: '',
            description: '',
            branch_id: null,
            image: null,
            knowledgeIds: [],
            stepIds: [],
            common: false,
            active: true
        };
        // Load options first
        await this.loadBranches();
        await this.loadSteps();
        console.log('DEBUG: Options loaded, stepOptions:', this.stepOptions);
        // Then load profession data if editing
        if (this.professionId) {
            await this.loadProfession();
        }
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadBranches() {
        var _a;
        try {
            const response = await this.apiService.back.get('branch.list');
            const branches = response.data;
            if (branches) {
                this.branchOptions = branches.map(branch => ({
                    label: branch.name,
                    value: branch.id
                }));
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('profession.form.branches.load.error'.t(), 'error');
        }
    }
    async loadSteps() {
        var _a;
        try {
            const response = await this.apiService.back.get('step.list');
            const steps = response.data;
            if (steps) {
                this.stepOptions = steps.map(step => ({
                    label: step.title,
                    value: step.id.toString() // Ensure string values
                }));
                console.log('Loaded step options:', this.stepOptions);
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('profession.form.steps.load.error'.t(), 'error');
        }
    }
    async loadProfession() {
        var _a;
        if (!this.professionId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('profession.get', {
                routeParams: { id: this.professionId }
            });
            const profession = response.data;
            if (profession) {
                // Ensure stepIds are properly loaded as string array
                const stepIds = profession.steps ? profession.steps.map(s => s.id.toString()) : [];
                console.log('DEBUG: Loading profession with steps:', stepIds);
                console.log('DEBUG: Available step options:', this.stepOptions);
                console.log('DEBUG: Profession steps raw:', profession.steps);
                // Update form with loaded data
                this.form = {
                    name: profession.name,
                    description: profession.description,
                    branch_id: profession.branch_id,
                    image: profession.image,
                    knowledgeIds: profession.knowledgeEntries ? profession.knowledgeEntries.map(k => k.id.toString()) : [],
                    stepIds: stepIds,
                    common: profession.common || false,
                    active: profession.active !== undefined ? profession.active : true
                };
                console.log('DEBUG: Form after initial loading:', this.form);
                // Force multiple reactivity updates to ensure checkboxes get the values
                setTimeout(() => {
                    console.log('DEBUG: First reactivity update - stepIds:', this.form.stepIds);
                    this.form = { ...this.form };
                }, 10);
                setTimeout(() => {
                    console.log('DEBUG: Second reactivity update - stepIds:', this.form.stepIds);
                    this.form = { ...this.form };
                    // Also manually trigger change on checkbox component if it exists
                    const checkboxComponent = this.$('part-checkbox[name="stepIds"]');
                    if (checkboxComponent) {
                        console.log('DEBUG: Manually updating checkbox component');
                        checkboxComponent.value = this.form.stepIds;
                        checkboxComponent.selectedValues = [...this.form.stepIds];
                    }
                }, 100);
            }
        }
        catch (e) {
            console.error('Error loading profession:', e);
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('profession.form.load.error'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    back() {
        component_2.SiteMenu.goto.bind(this)('/profession/list');
    }
    async handleSubmit(event) {
        var _a, _b, _c, _d;
        event.preventDefault();
        try {
            this.loading = true;
            let response;
            let actionText = this.professionId ? 'updated' : 'created';
            if (!this.form.branch_id) {
                const branchVal = this.$('part-select[name="branch_id"]').getElement().value;
                this.form.branch_id = branchVal;
            }
            if (this.professionId) {
                response = await this.apiService.back.put('profession.update', this.form, { routeParams: { id: this.professionId } });
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('profession.form.update.success'.t(), 'info');
            }
            else {
                response = await this.apiService.back.post('profession.create', this.form);
            }
            // (this.$('the-form') as FormComponent).reset();
            if (response && response.success) {
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify(`${'profession.form.action.success'.t()} ${actionText}`, 'info');
                this.form = {
                    name: '',
                    description: '',
                    branch_id: null,
                    image: null,
                    knowledgeIds: [],
                    stepIds: [],
                    common: false,
                    active: true
                };
                this.back();
            }
            else {
                (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify(`${'profession.form.action.error'.t()} ${actionText}`, 'error');
            }
        }
        catch (e) {
            (_d = this.notifyService) === null || _d === void 0 ? void 0 : _d.notify(`${'profession.form.action.failed'.t()} ${this.professionId ? 'profession.form.update'.t() : 'profession.form.create'.t()}`, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    onImageUpload(event) {
        const file = event.detail;
        this.form.image = file;
    }
    onKnowledgeSelectionChanged(event) {
        this.form.knowledgeIds = event.detail.selectedIds;
    }
    onStepSelectionChanged(event) {
        const values = event.detail.value || [];
        this.form.stepIds = Array.isArray(values) ? values.map(v => v.toString()) : [];
        console.log('DEBUG: Step selection changed:', this.form.stepIds);
        console.log('DEBUG: Event detail:', event.detail);
        // Trigger reactivity
        this.form = { ...this.form };
    }
};
exports.ProfessionForm = ProfessionForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ProfessionForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ProfessionForm.prototype, "professionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof profession_types_1.IProfessionPayload !== "undefined" && profession_types_1.IProfessionPayload) === "function" ? _a : Object)
], ProfessionForm.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ProfessionForm.prototype, "branchOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ProfessionForm.prototype, "stepOptions", void 0);
exports.ProfessionForm = ProfessionForm = __decorate([
    (0, client_1.RWSView)('profession-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ProfessionForm);
ProfessionForm.defineComponent();
